export const FILTER_TYPE = {
    RANGE: 'RANGE'
};